import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CoberturasSecundariasComponent } from '../coberturas-secundarias/coberturas-secundarias.component';
import { AsistenciasComponent } from '../asistencias/asistencias.component';
import { SendMailCotizacionComponent } from 'src/app/blocks/send-mail-cotizacion/send-mail-cotizacion.component';

@Component({
  selector: 'app-planes-recomendados',
  templateUrl: './planes-recomendados.component.html',
  styles: []
})
export class PlanesRecomendadosComponent implements OnInit {

  @Input()
  type: string = "SHOW3";

  @Input()
  lead: any = {};

  @Input()
  maxSa: number = 0;

  @Input()
  minSa: number = 0; 

  @Input()
  planes: any;

  @Output()
  selectPlan: EventEmitter<any>;

  @Output()
  sendMailClick: EventEmitter<any>;

  @Output()
  sendMailOk: EventEmitter<any>;

  @Input()
  cotizador: string = "";

  slideConfig: any = {
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
          arrows:true,
          initialSlide: 0
        }
      }
    ]
  };

  planSelected: any;
  isPlanSelected: boolean = false;

  constructor(
    private modalService: NgbModal,
  ) {
    this.selectPlan = new EventEmitter();
    this.sendMailClick = new EventEmitter();
    this.sendMailOk = new EventEmitter();
  }

  slidesReady: boolean = false;
  ngOnInit() {
    if(this.lead.sa == this.minSa){
      console.log("min");
      this.slideConfig.responsive[0].settings.initialSlide = 0;
    }

    if(this.lead.sa == this.maxSa){
      console.log("max");
      this.slideConfig.responsive[0].settings.initialSlide = 2;
    }

    if((this.lead.sa != this.minSa) && (this.lead.sa != this.maxSa)){
      console.log("medio");
      this.slideConfig.responsive[0].settings.initialSlide = 1;
    }

    this.slidesReady = true;
  }

  doSelectPlan(plan: any, name: any) {
    plan.displayName = name;
    this.selectPlan.emit({
      plan: plan
    });
  }

  doSelectPlanRadio(plan: any){
    this.planSelected = plan;
    this.isPlanSelected = true;
  }

  viewMore(plan: any) {
    console.log(plan);
    const modalRef = this.modalService.open(CoberturasSecundariasComponent, { size: 'lg' });
    modalRef.componentInstance.plan = plan;
  }

  viewAsistencias(plan: any) {
    const modalRef = this.modalService.open(AsistenciasComponent, { size:'sm'  });
    modalRef.componentInstance.plan = plan;
  }

  sendMail(lead: any, cotizacion: any) {
    this.sendMailClick.emit();
    const modalRef = this.modalService.open(SendMailCotizacionComponent, { size: <any>'bici-editar-datos' });
    modalRef.componentInstance.lead = lead;
    modalRef.componentInstance.cotizacion = cotizacion;

    modalRef.result.then((data) => {
		  this.sendMailOk.emit();
		}, (reason) => {
		  this.sendMailOk.emit();
		});

  }
}
